import { render, staticRenderFns } from "./HomeMobile.vue?vue&type=template&id=72945912&scoped=true"
import script from "./HomeMobile.vue?vue&type=script&lang=js"
export * from "./HomeMobile.vue?vue&type=script&lang=js"
import style0 from "./HomeMobile.vue?vue&type=style&index=0&id=72945912&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72945912",
  null
  
)

export default component.exports